import { combineReducers } from "redux";

import invoices from "./invoices";
import clients from "./clients";
import auth from "./auth";
import profiles from "./profiles";
import upload from "./upload";
import categories from "./categories";
import items from "./items";
import contactus from "./contactus";
import companies from "./companies";
import companyProfile from "./companyProfile";
import userGroups from "./groups";
import users from "./users";
import rentals from "./rentals";
import buildings from "./buildings";
import units from "./units";
import transactions from "./transaction";
import letters from "./letters";
import accounts from "./account";
import purchaseInvoices from "./purchaseInvoices.js";
import attendance from "./attendanceReducer.js";
import payrolls from "./payrollReducer.js";
import tax from "./tax.js";
import assets from "./assets.js";
import barcodeSettings from "./barcodeSettings.js";
import costcenters from "./costCenters.js";
import profitCenters from "./profitCenters.js";
import projects from "./projects.js";
import smsProviders from "./smsProviders.js";
import notifications from "./notifications.js";
import smsSettings from "./smsSettings";
import vouchers from "./vouchers.js";
import coupons from "./coupons.js";
import emailSettingsReducer from "./EmailSettingsReducer.js";
import communication from "./communication.js";
import ProductPackageReducer from "./ProductPackages.js";
import features from "./features.js";
import translation from "./translation.js";
import accountingSettings from "./accountingSettings.js";
import clinic from "./clinic.js";
import properties from "./properties.js";
import property from "./property.js";
import messaging from "./messaging.js";
import inventory from "./inventory.js";
import unitOfMeasure from "./unitOfMeasure.js";
import warehouse from "./warehouse.js";
import inventoryAdjustments from "./inventoryAdjustments.js";
import inventoryTransactions from "./inventoryTransactions.js";
import settings from "./settings.js";
import attribute from "./attribute.js";
import journals from "./journals.js";
import payments from "./payments.js";
import pos from "./pos.js";
import subscription from "./subscription.js";
import discountCodes from "./discountCodeReducer.js";
import excelImport from "./excelImportReducer.js";
import excelExport from "./excelExportReducer.js";
import qrCodes from "./qrCodeReducer.js";
import construction from "./constructionReducer.js";
import boq from "./boqReducer.js";
import progressBilling from "./progressBillingReducer.js";
import lawCases from "./lawCaseReducer.js";
import timeEntries from "./timeEntryReducer.js";
import lawTasks from "./lawTaskReducer.js";
import lawExpenses from "./lawExpenseReducer.js";
import documentTemplates from "./documentTemplateReducer.js";
import lawMatters from "./lawMatters.js";
import todo from "./todo.js";
import projectBudget from './projectBudget';
import projectExpense from './projectExpense';
import subcontractors from './subcontractorReducer';
import materialRequests from './materialRequestReducer';
import dailyReports from './dailyReportReducer';
import constructionReports from './constructionReportReducer';
import creditDebitNotes from './creditDebitNotes';
import inventoryOrders from './inventoryOrders';
import workflow from './workflowReducer';
import manufacturing from './manufacturingReducer';

export default combineReducers({
  invoices,
  clients,
  auth,
  profiles,
  upload,
  categories,
  items,
  contactus,
  companies,
  companyProfile,
  userGroups,
  users,
  rentals,
  buildings,
  units,
  transactions,
  letters,
  accounts,
  purchaseInvoices,
  attendance,
  payrolls,
  tax,
  assets,
  barcodeSettings,
  costcenters,
  profitCenters,
  projects,
  smsProviders,
  notifications,
  smsSettings,
  vouchers,
  coupons,
  emailSettingsReducer,
  communication,
  ProductPackageReducer,
  features,
  translation,
  accountingSettings,
  properties,
  clinic,
  property,
  messaging,
  inventory,
  unitOfMeasure,
  warehouse,
  inventoryAdjustments,
  inventoryTransactions,
  settings,
  attribute,
  journals,
  payments,
  pos,
  subscription,
  discountCodes,
  excelImport,
  excelExport,
  qrCodes,
  construction,
  boq,
  progressBilling,
  lawCases,
  timeEntries,
  lawTasks,
  lawExpenses,
  documentTemplates,
  lawMatters,
  todo,
  projectBudget,
  projectExpense,
  subcontractors,
  materialRequests,
  dailyReports,
  constructionReports,
  creditDebitNotes,
  inventoryOrders,
  workflow,
  manufacturing,
});
